export default class CookieBanner {
    constructor({ el }) {
        
        // document.addEventListener('DOMContentLoaded', function () {
            const cookieBanner = el;
            const acceptButton = el.querySelector('.control.accept');
            const rejectButton = el.querySelector('.control.refuse');
            const shadowButton = el.querySelector('.shadow');
            const closeButton = el.querySelector('.close');

            this.gaId = 'G-ZKTFD6T54D';

            // Function to set a cookie
            function setCookie(name, value, days) {
                let expires = '';
                if (days) {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = '; expires=' + date.toUTCString();
                }
                document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax';
            }

            // Function to get a cookie
            function getCookie(name) {
                const nameEQ = name + '=';
                const ca = document.cookie.split(';');
                for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
                }
                return null;
            }


            closeButton.addEventListener('click', function () {
                cookieBanner.style.display = 'none';
            });
            shadowButton.addEventListener('click', function () {
                cookieBanner.style.display = 'none';
            });

            // Check if cookie consent exists
            if (!getCookie('cookieConsent')) {
                cookieBanner.style.display = 'flex';
            }

            // Accept all cookies
            acceptButton.addEventListener('click', function () {
                setCookie('cookieConsent', 'accepted', 365);
                setCookie('analyticsCookies', 'true', 365);
                setCookie('marketingCookies', 'true', 365);
                cookieBanner.style.display = 'none';
                loadCookies();
            });

            // Reject non-essential cookies
            rejectButton.addEventListener('click', function () {
                setCookie('cookieConsent', 'rejected', 365);
                setCookie('analyticsCookies', 'false', 365);
                setCookie('marketingCookies', 'false', 365);
                cookieBanner.style.display = 'none';
            });

            // Load cookies based on user preferences
            const loadCookies = () => {
                if (getCookie('analyticsCookies') === 'true') {
                    this.initGoogleAnalytics(this.gaId);
                }
                if (getCookie('marketingCookies') === 'true') {
                    // Example: Load marketing scripts
                    // console.log('Loading marketing cookies...');
                    // Add your marketing scripts here
                }
            }

            // Load cookies if consent exists
            if (getCookie('cookieConsent')) {
                loadCookies();
            }
        // });
    }
    initGoogleAnalytics(id) {
        console.log("WICWJCIW", id)
        // Prevent duplicate injection
        if (window.gtag) return;

        // 1. Inject the external script
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
        document.head.appendChild(script);

        // 2. Setup the gtag function
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        window.gtag = gtag; // Make it globally accessible
        
        gtag('js', new Date());
        gtag('config', id);
    }
    dispose() {

    }
}